import { render, staticRenderFns } from "./VideoJitsi.vue?vue&type=template&id=62e5b048"
import script from "./VideoJitsi.vue?vue&type=script&lang=js"
export * from "./VideoJitsi.vue?vue&type=script&lang=js"
import style0 from "./VideoJitsi.vue?vue&type=style&index=0&id=62e5b048&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports